import { render, staticRenderFns } from "./backtoschool.vue?vue&type=template&id=7e287a6e"
import script from "./backtoschool.vue?vue&type=script&lang=js"
export * from "./backtoschool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports